import * as React from 'react';
export var ImageCard = function (_a) {
    var image = _a.image, title = _a.title, description = _a.description, details = _a.details;
    return (React.createElement("div", { className: "card image-card text-center".concat(details ? ' details' : '') },
        React.createElement("div", { className: "image" },
            React.createElement("img", { src: image, alt: typeof title === 'string' ? title : 'Logo' })),
        React.createElement("h5", null, title),
        React.createElement("div", null,
            React.createElement("small", null, description)),
        details && React.createElement("div", { className: "card-details" }, details)));
};
//# sourceMappingURL=index.js.map